import style from './index.module.scss';
export default function NoData() {
    return (
      <div className={style.not_data}>
        <img src='/images/common/no_data.png' alt={'NoData'}  />
      </div>)
}